<template>
  <tr :class="[settings.Styles.BorderStyle, backGroundStyle, evenRowClass]">
    <td v-if="settings.ColumnSettings.ShowImage" class="col-xs-12 col-sm-3 sm-table-cell col-md-2 md-table-cell" :class="[settings.Styles.BorderStyle]">
      <div class="image col-xs-6 col-xs-offset-3 col-sm-12 col-sm-offset-0">
        <img class="lazypreload lazyloaded" :src="imageUrl" />
      </div>
    </td>
    <td class="col-xs-12" :class="[settings.Styles.BorderStyle]">
      <div class="help-block"></div>
      <a :href="orderline.MainProductUrl">{{orderline.MainProductName}}</a>

      <ul class="list-unstyled" v-if="orderline.Items.length > 1">
        <li v-for="option in optionItems">
          <b>+</b><i>option.Name</i>
        </li>
      </ul>
    </td>
    <td v-if="settings.ColumnSettings.ShowUnitPerPack" class="col-xs-12" :class="[settings.Styles.BorderStyle]">
      <b class="hidden visible-xs-inline">UnitPerPack:</b>
      <span>{{orderline.UnitPerPack}}</span>
    </td>
    <td v-if="settings.ColumnSettings.ShowPrice" class="col-xs-12" :class="[settings.Styles.BorderStyle]">
      <b class="hidden visible-xs-inline">{{settings.ColumnLabels.PriceLable}}:</b>
      <!--<div data-orderLine-unitPrice-withoutDiscounts style="text-decoration: line-through; @EqualForHide(orderLine.UnitPriceWithoutDiscounts.Value, orderLine.UnitPrice.Value)">@(orderLine.HasPriceInconsistancy ? "" : orderLine.UnitPriceWithoutDiscounts.DisplayPrice().PriceOnly)</div>-->
      <span class="productDisplayPriceStyle">{{settings.PriceSettings.ExcludeVat ? orderline.UnitPrice.Formatted : orderline.UnitPrice.WithVatFormatted}}</span>
    </td>
    <td v-if="settings.ColumnSettings.ShowDefaultPrice" class="col-xs-12" :class="[settings.Styles.BorderStyle]">
      <b class="hidden visible-xs-inline">{{settings.ColumnLabels.DefaultPriceLable}}:</b>
      <span class="productDefaultDisplayPriceStyle">{{displayDefaultPrice}}</span>
    </td>
    <td v-if="settings.ColumnSettings.ShowDiscountOfCurrentAndDefaultPrice" class="col-xs-12" :class="[settings.Styles.BorderStyle]">
      <b class="hidden visible-xs-inline">{{settings.ColumnLabels.DiscountOfCurrentAndDefaultPriceLable}}:</b>
      <span>{{discountOfCurrentAndDefaultPrice}}</span>
    </td>
    <td v-if="settings.ColumnSettings.ShowStock" class="col-xs-12" :class="[settings.Styles.BorderStyle]">
      <b class="hidden visible-xs-inline">{{settings.ColumnLabels.StockLable}}:</b>
      <span v-if="!settings.ColumnSettings.ProductStockIsRealTimeLookup">{{orderline.DisplayStock}}</span>
      <a v-else class="openBranchesSlideSection" @click="branchesSlideSectionTrigger()">{{settings.ColumnLabels.RealtimeStockLookupButtonText}}</a>
    </td>
    <td class="quantityInput col-xs-12" :class="[settings.Styles.BorderStyle]">
      <b class="hidden visible-xs-inline">{{settings.ColumnLabels.QuantityLable}}:</b>
      <div class="input-group tag-center btn-3-group" :class="[settings.Styles.BorderStyle]">
        <span class="input-group-btn">
          <button type="button" class="btn btn-danger btn-number c2-bg" @click="minusQuantity()">
            <span class="glyphicon glyphicon-minus"></span>
          </button>
        </span>
        <input type="text" name="quantity" class="form-control input-number quantity" v-model="orderline.Quantity" @change="quantityChanged()">
        <span class="input-group-btn">
          <button type="button" class="btn btn-success btn-number" :class="[settings.Styles.ButtonStyle]" @click="addQuantity()">
            <span class="glyphicon glyphicon-plus"></span>
          </button>
        </span>
        <span class="input-group-btn">
          <button type="button" class="btn btn-danger btn-number c2-bg" v-on:click="deleteOrderline(orderline.Id)">
            <span class="glyphicon glyphicon-remove"></span>
          </button>
        </span>
      </div>
    </td>
    <td v-if="settings.ColumnSettings.ShowTotal" class="col-xs-12 text-sm-right text-center" :class="[settings.Styles.BorderStyle]">
      <b class="hidden visible-xs-inline">Total:</b>
      <span data-orderLine-totalPrice>{{settings.PriceSettings.ExcludeVat ? orderline.LineTotal.Formatted : orderline.LineTotal.WithVatFormatted}}</span>
    </td>
  </tr>
</template>
<script>
  import { OrderService } from "../../Models/Order/OrderService";
  import ImageService from "../../Models/Media/ImageService";

  export default {
    name: "Orderline",
    props: {
      orderline: {
        type: Object
      },
      settings: {
        type: Object
      },
      rowIndex: {
        type: Number
      },
      active: {
        type: Boolean,
        default: () => false
      }
    },
    data() {
      return {
        targetRealTimeStockMiniSectionId: 'miniBranchesSection',
      };
    },
    computed: {
      orderService: function () {
        return new OrderService();
      },
      imageUrl: function () {
        const imageService = new ImageService();
        const url = `${window.location.origin}/${this.orderline.MainProductImageUrl}`;
        const imageParams = imageService.getImageStyleQueryParams(this.settings.ColumnSettings.ImageStyle);
        const queryParams = { ...this.orderline.MainProductImageDefaultSettings, ...imageParams };
        const imageUrl = imageService.getCropUrl(url, queryParams);
        return imageUrl;
      },
      mainItem: function () {
        return this.orderline.Items.find(v => v.ProductIdentifier === this.orderline.MainProductId);
      },
      optionItems: function () {
        return this.orderline.Items.filter(v => v.ProductIdentifier !== this.orderline.MainProductId);
      },
      evenRowClass: function () {
        return this.rowIndex % 2 !== 0 ? 'bg-perc_30' : '';
      },
      backGroundStyle: function () {
        return this.active ? this.settings.Styles.LastEditRowSettings.BackGroundStyle : this.settings.Styles.BackGroundStyle;
      },
      displayDefaultPrice: function () {
        const defaultPrice = this.orderline.DefaultPrice.Value;
        const currentPrice = this.orderline.UnitPrice.Value;

        if (defaultPrice <= 0) { return ''; }

        return this.settings.PriceSettings.ExcludeVat ? this.orderline.DefaultPrice.Formatted : this.orderline.DefaultPrice.WithVatFormatted;
      },
      discountOfCurrentAndDefaultPrice: function () {
        const defaultPrice = this.orderline.DefaultPrice.Value;
        const currentPrice = this.orderline.UnitPrice.Value;

        if (defaultPrice === 0 || currentPrice >= defaultPrice) { return ''; }

        return ((defaultPrice - currentPrice) * 100 / defaultPrice).toFixed(2) + '%';
      }
    },
    methods: {
      quantityChanged() {
        //console.log('quantityChanged()', this.orderline.Quantity);
        this.addToCart(this.orderline.Id, this.orderline.Quantity, true);
      },
      addToCart(id, qty, overwriteQuantity) {
        this.orderService.addOrUpdateOrderLineById(id, qty, overwriteQuantity)
          .then(({ data }) => {
            $.refreshSiteAfterCartUpdateForBundle(data);
          });
      },
      deleteOrderline(id) {
        this.orderService.deleteOrderline(id)
          .then(({ data }) => {
            $.refreshSiteAfterCartUpdateForBundle(data);
          });
      },
      addQuantity() {
        this.orderService.addOrUpdateOrderLineQuantityById(this.orderline.Id, this.orderline.Quantity, this.orderline.MinimumQuantity, this.orderline.StepQuantity)
          .then(({ data }) => {
            $.refreshSiteAfterCartUpdateForBundle(data);
          });
      },
      minusQuantity() {
        this.orderService.minueOrderLineQuantityById(this.orderline.Id, this.orderline.Quantity, this.orderline.MinimumQuantity, this.orderline.StepQuantity)
          .then(({ data }) => {
            $.refreshSiteAfterCartUpdateForBundle(data);
          });
      },
      //getEvenRowClass: function (i) {
      //  //console.log('getEvenRowClass', i);
      //  return i % 2 !== 0 ? 'bg-perc_30' : '';
      //}
      branchesSlideSectionTrigger() {
        //console.log('branchesSlideSectionTrigger');
        var linkData = {
          internalId: this.orderline.MainProductId,
        };

        $.openMiniSlideSection(this.targetRealTimeStockMiniSectionId);
        $.branchesSlideSectionTrigger(linkData);
      }
    }
  };
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// EcomCore/Components/Products/Orderline.vue